import { render, staticRenderFns } from "./PhotoSwiperSmall.vue?vue&type=template&id=031b1392&"
import script from "./PhotoSwiperSmall.vue?vue&type=script&lang=js&"
export * from "./PhotoSwiperSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports